import { Observable, of } from 'rxjs';
import { DateTime } from 'luxon';
import { Valid } from 'luxon/src/_util';
import { downTimeData } from '../data/downtime.data.mock';
import { IRowData } from '../../model/dto/rowdata.type';

export class EventsScheduleApiServiceMock {

    public getEventsSchedule(
        begin: DateTime<Valid>,
        end: DateTime<Valid>,
        type: 'AVAILABILITY',
        portfolioId: '123e4567-e89b-12d3',
        siteId: 'e8-4003',
    ): Observable<IRowData[]> {
        return of(downTimeData);
    }

    public getAllAvailabilitySchedulesV1(
        begin: DateTime<Valid>,
        end: DateTime<Valid>,
        type: 'AVAILABILITY',
        portfolioId: '123e4567-e89b-12d3',
        siteId: 'e8-4003',
    ): Observable<IRowData[]> {
        return of(downTimeData);
    }
}
